export default "__VITE_ASSET__3m76xbXr__"